import React from 'react';
import {  Datagrid,DateInput,Responsive,SimpleList,NumberField,DateField,Show,ShowButton,List, TextField, SimpleShowLayout,ReferenceInput,Filter,SelectInput,FunctionField } from 'admin-on-rest/lib/mui';
 
const dateFormatter = v => {
  // v is a string of "YYYY-MM-DD" format
  const match = /(\d{4})-(\d{2})-(\d{2})/.exec(v);
  if (match === null) return;
  const d = new Date(match[1], parseInt(match[2])-1, match[3]);
  if (isNaN(d)) return;
  return d;
};

const dateParser = v => {
  // v is a `Date` object
  if (!(v instanceof Date) || isNaN(v)) return;
  const pad = '00';
  const yy = v.getFullYear().toString();
  const mm = ((v.getMonth() + 1).toString());
  const dd = v.getDate().toString();
  return `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
};

var minDate=new Date();
minDate.setDate(minDate.getDate()-180);
const AggregatesFilter = (props) => (
    
    <Filter {...props} >
         <ReferenceInput label="בית עסק" source="id" reference="customers" perPage={500} sort={{ field: 'name_heb', order: 'ASC' }} allowEmpty>
            <SelectInput optionText="name_heb" />
        </ReferenceInput>
      
  <ReferenceInput label="תוכנית זיכוי" source="zicui_date_plan_id" reference="zicuidateplans" alwaysOn defaultValue ="1" allowEmpty="False" >
<SelectInput optionText="name" />
</ReferenceInput>

    </Filter>
);

const rowStyle = (record) => {
    if (record.commission_ammount <0) return { backgroundColor: '#fdd' };
    
    return {};
};


const HafkadotAggregatesStyle = {
   overflow:'visible'
};


export const HafkadotAggregatesList = (props) => (
    <List title="דף חשבון" perPage={30} {...props}  filters={<AggregatesFilter /> }>
      <Responsive
       small={
                <SimpleList
                    primaryText={record =>"תאריך הפקדה"+ new Date(record.deposit_date.date).toLocaleDateString()}
                    secondaryText={record =>"סוג עסקה"+ record.tnuaa_type}
                    tertiaryText={record =>"מספר ריכוז"+ record.rikuz_number}
                   
                    
                />
            }
 medium={

          <Datagrid  rowStyle={rowStyle} bodyOptions={{showRowHover: true }}>
            
<TextField style={HafkadotAggregatesStyle} label="#" source="id" />

<TextField style={HafkadotAggregatesStyle} label="תקופה" source="yearmonth" />



<NumberField style={HafkadotAggregatesStyle} label="ברוטו לזיכוי" source="zikuiNIS" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField style={HafkadotAggregatesStyle} label="ב.ללא תשלומים" source="zikuiNISNOTashlumim" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField style={HafkadotAggregatesStyle} label="ב.תשלומים בלבד" source="zikuiNISTashlumim" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />

<NumberField style={HafkadotAggregatesStyle} label="סכום לחישוב עמלה" source="zikuiNISForAmla" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />




    
<NumberField style={HafkadotAggregatesStyle} label="סהכ עסקאות תייר" source="zikuiNISTayar" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField style={HafkadotAggregatesStyle} label="תשלום קבוע" source="monthly_fee" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField style={HafkadotAggregatesStyle} label="CAP" source="monthly_cap" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />

<NumberField style={HafkadotAggregatesStyle} label="ביטולים" source="bitulim" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />

<NumberField style={HafkadotAggregatesStyle} label="עמלה" source="commission" locales="he-IL" options={{ style: 'percent', minimumFractionDigits: 1,maximumFractionDigits: 2 }} />
<NumberField style={HafkadotAggregatesStyle} label="עמלת תייר" source="tourist_card_commision" locales="he-IL" options={{ style: 'percent', minimumFractionDigits: 1,maximumFractionDigits: 2 }} />

<NumberField style={HafkadotAggregatesStyle} label="סהכ עמלות תייר" source="tourist_card_commision_total" locales="he-IL" options={{  currency: 'ILS', style: 'currency', minimumFractionDigits: 1,maximumFractionDigits: 2 }} />
<NumberField style={HafkadotAggregatesStyle} label="סהכ עמלות ללא חודשי" source="total_amlot_no_monthly" locales="he-IL" options={{  currency: "ILS", style: 'currency', minimumFractionDigits: 1,maximumFractionDigits: 2 }} />

<NumberField style={HafkadotAggregatesStyle} label="סהכ עמלות" source="total_amlot" locales="he-IL" options={{  currency: "ILS", style: 'currency', minimumFractionDigits: 1,maximumFractionDigits: 2 }} />

<NumberField style={HafkadotAggregatesStyle} label="נטו לזיכוי"  source="total_haavara" locales="he-IL" options={{  currency: "ILS", style: 'currency', minimumFractionDigits: 1,maximumFractionDigits: 2 }} />



    
          
        </Datagrid>
 }
         />
    </List>
);


const HafkadotRicuzMonthTitle = ({ record }) => {
    return <span>מספר {record ? `"${record.id}"` : ''}</span>;
};







// WEBPACK FOOTER //
// ./src/components/HafkadotAggregates/aggregates.js